import type { SelectChangeEvent } from '@ori-ui/mui';
import { Typography, styled } from '@ori-ui/mui';
import type { DetailedHTMLProps, HTMLProps } from 'react';
import { forwardRef, useContext } from 'react';
import { useIntl } from 'react-intl';

import { localization } from '../../../shared/constants';
import { frequencies } from '~/AutoshipWizard/constants/frequencies';
import { SelectField } from '~/shared/components';
import { stateContext } from '~/shared/contexts';

const FormGrid = styled('form')(({ theme }) => ({
  display: 'grid',
  rowGap: theme.spacing(1),
}));

export const FrequencySelection = forwardRef<
  HTMLFormElement,
  DetailedHTMLProps<HTMLProps<HTMLFormElement>, HTMLFormElement>
>(({ onChange }, ref) => {
  const { formatMessage } = useIntl();
  const { setFrequency, selectedFrequency } = useContext(stateContext);

  const selectFrequency = formatMessage({
    id: 'selectFrequency',
    defaultMessage: localization.selectFrequency,
  });

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const frequencyToSave = frequencies.find((frequency) => frequency.Value === event.target.value);
    setFrequency(frequencyToSave);
  };

  const mapFrequencies = frequencies.map(({ Value, Message }) => ({
    Id: Value,
    Text: formatMessage(Message),
  }));

  return (
    <FormGrid
      ref={ref}
      autoComplete="off"
      onChange={onChange}
    >
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold' }}
      >
        {selectFrequency}
      </Typography>
      <SelectField
        displayEmpty
        id="frequency"
        placeholder={selectFrequency}
        value={selectedFrequency?.Value}
        items={mapFrequencies}
        // eslint-disable-next-line react/jsx-no-bind -- Callback passed as reference is fine.
        onChange={handleChange}
      />
    </FormGrid>
  );
});
